/** @format */
import { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';
import { theme } from '@toucan/client/global/theme';

export const styles = css`
    display: flex;
    flex-direction: column;
    padding-bottom: var(--layout-spacing-32);
    overflow-y: auto;

    &:after {
        content: '';
        position: absolute;
        bottom: 6.1rem;
        left: 0;
        right: 0;
        height: 5.2rem;
        background: var(--gradients-surface-fade-down-full-opacity);
        pointer-events: none;
        z-index: 100;
        transition: opacity 140ms linear;
        opacity: 1;
    }

    .filter-description {
        ${theme.typography.body_small}
        margin-bottom: var(--layout-spacing-8);
    }

    .filter-section {
        h5 {
            ${theme.typography.body_small_highlight}
            margin: var(--layout-spacing-16) var(--layout-spacing-24) 0;
        }

        ul {
            margin-top: var(--layout-spacing-4);
        }
    }

    .filter-options {
        min-height: initial;

        ul {
            margin-top: 1rem;
            overflow-y: initial;
            max-height: initial;
        }

        &:after {
            display: none;
        }
    }

    ${smallTablet(css`
        padding-bottom: 0;

        &:after {
            display: none;
        }

        .filter-description {
            margin-bottom: 0;
        }

        .header {
            margin-bottom: var(--layout-spacing-16);

            h4 {
                margin: 0 0 var(--layout-spacing-8);
                font-weight: 400;
                font-size: 1.6rem;
            }
        }

        .filter-section {
            margin-bottom: var(--layout-spacing-16);

            + .header {
                margin-top: var(--layout-spacing-8);
            }

            h5 {
                margin: 0 0 var(--layout-spacing-2);
            }

            ul {
                margin-top: 0;
            }
        }

        .filter-options {
            ul {
                margin-top: 0;
            }
        }
    `)}
`;
